export const DOWNLOAD_TYPES = ['free', 'paid', 'subscription', 'direct']

const ORIGIN_KEY_PREFIX = 'downloadOrigin'
const ORIGIN_MAX_AGE_MS = 30 * 60 * 1000
const FALLBACK_PAGE_TYPE = 'other'
const PAGE_TYPES_BY_PATH_PREFIX = [
  ['/profile/purchases', 'purchases'],
  ['/profile/liked_models', 'liked_models'],
  ['/profile/models', 'my_models'],
  ['/orders/', 'order'],
  ['/my-hub', 'my_hub'],
]

export function rememberDownloadOrigin({ itemId, pageType, itemListName = '' }) {
  if (!itemId) {
    return
  }

  try {
    window.localStorage.setItem(
      `${ORIGIN_KEY_PREFIX}${itemId}`,
      JSON.stringify({ page_type: pageType, item_list_name: itemListName, saved_at: Date.now() }),
    )
  } catch {
    // noop
  }
}

function isFresh(origin, now) {
  return Boolean(origin?.page_type) && now - origin.saved_at < ORIGIN_MAX_AGE_MS
}

function pruneExpiredOrigins(now) {
  const { localStorage } = window

  Object.keys(localStorage)
    .filter((key) => key.startsWith(ORIGIN_KEY_PREFIX))
    .forEach((key) => {
      try {
        if (!isFresh(JSON.parse(localStorage.getItem(key)), now)) {
          localStorage.removeItem(key)
        }
      } catch {
        localStorage.removeItem(key)
      }
    })
}

export function readDownloadOrigin(itemId) {
  try {
    const now = Date.now()
    const origin = JSON.parse(window.localStorage.getItem(`${ORIGIN_KEY_PREFIX}${itemId}`))

    pruneExpiredOrigins(now)

    return isFresh(origin, now) ? origin : null
  } catch {
    return null
  }
}

export function pageTypeForPath(pathname = '') {
  const match = PAGE_TYPES_BY_PATH_PREFIX.find(([prefix]) => pathname.startsWith(prefix))

  return match ? match[1] : FALLBACK_PAGE_TYPE
}

export function downloadModelEventData({ itemId, fileId, itemPrice, downloadType, pageType, itemListName = '' }) {
  return {
    item_id: itemId,
    file_id: fileId,
    item_price: itemPrice,
    is_free_download: downloadType === 'free' ? 1 : 0,
    download_type: downloadType,
    page_type: pageType,
    item_list_name: itemListName,
  }
}
